module.exports = __webpack_public_path__ + "static/modelo1-e760690e588c21791db6c62f0535773a.png";